const ENSEIGNE_CONST = {
  POINTP: 'pointp',
  CEDEO: 'cedeo'
}

export default ENSEIGNE_CONST
